import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiHome, FiSend, FiSettings, FiArrowDownLeft } from 'react-icons/fi';
import { RiSwapLine } from 'react-icons/ri';
import '../styles/Footer.css';
import Logo from '../logo.svg';

// Modern SVGs for nav
// Modern SVGs for nav (Filled/Soft Style)
const HomeIcon = ({ active }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.15344 3.3276L2.94632 8.5526C2.34832 9.0526 2 9.7776 2 10.5526V18.5276C2 20.4526 3.55 22.0026 5.475 22.0026H18.525C20.45 22.0026 22 20.4526 22 18.5276V10.5526C22 9.7776 21.6517 9.0526 21.0537 8.5526L14.8466 3.3276C13.2466 1.9776 10.7534 1.9776 9.15344 3.3276Z" fill={active ? "#2B5AFF" : "currentColor"} fillOpacity={active ? 1 : 0.4} />
  </svg>
);
const ReceiveIcon = ({ active }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.525 2H5.475C3.55 2 2 3.55 2 5.475V11.525C2 13.45 3.55 15 5.475 15H18.525C20.45 15 22 13.45 22 11.525V5.475C22 3.55 20.45 2 18.525 2Z" fill={active ? "#2B5AFF" : "currentColor"} fillOpacity={active ? 1 : 0.4} />
    <path d="M12 22C11.575 22 11.175 21.825 10.875 21.525L7.375 18.025C6.925 17.575 6.925 16.875 7.375 16.425C7.825 15.975 8.525 15.975 8.975 16.425L12 19.45L15.025 16.425C15.475 15.975 16.175 15.975 16.625 16.425C17.075 16.875 17.075 17.575 16.625 18.025L13.125 21.525C12.825 21.825 12.425 22 12 22Z" fill={active ? "#2B5AFF" : "currentColor"} />
    <path d="M12 21.25C11.575 21.25 11.25 20.925 11.25 20.5V11.5C11.25 11.075 11.575 10.75 12 10.75C12.425 10.75 12.75 11.075 12.75 11.5V20.5C12.75 20.925 12.425 21.25 12 21.25Z" fill={active ? "#2B5AFF" : "currentColor"} />
  </svg>
);
const SendIcon = ({ active }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.6 11.125L13.1 2.625C12.5 2.025 11.5 2.025 10.9 2.625L2.40002 11.125C1.80002 11.725 1.80002 12.725 2.40002 13.325C3.00002 13.925 4.00002 13.925 4.60002 13.325L10.5 7.425V20.5C10.5 21.3 11.2 22 12 22C12.8 22 13.5 21.3 13.5 20.5V7.425L19.4 13.325C20 13.925 21 13.925 21.6 13.325C22.2 12.725 22.2 11.725 21.6 11.125Z" fill={active ? "#2B5AFF" : "currentColor"} fillOpacity={active ? 1 : 0.4} />
  </svg>
);
const SettingsIcon = ({ active }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" fill={active ? "#2B5AFF" : "currentColor"} fillOpacity={active ? 1 : 0.4} />
    <path d="M20.25 13.75C20.25 17.8921 16.8921 21.25 12.75 21.25C8.60786 21.25 5.25 17.8921 5.25 13.75C5.25 9.60786 8.60786 6.25 12.75 6.25C16.8921 6.25 20.25 9.60786 20.25 13.75Z" stroke={active ? "#2B5AFF" : "currentColor"} strokeWidth="2.5" />
  </svg>
);

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const navItems = [
    { icon: HomeIcon, label: 'Home', path: '/home' },
    { icon: ReceiveIcon, label: 'Receive', path: '/receive' },
    { icon: SendIcon, label: 'Send', path: '/send' },
    // { icon: RiSwapLine, label: 'Swap', path: '/swap' }, // Swap hidden
    { icon: SettingsIcon, label: 'Settings', path: '/settings' }
  ];

  return (
    <motion.div
      className="footer"
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <nav className="footer-nav">
        {navItems.map(({ icon: Icon, label, path }) => (
          <motion.button
            key={path}
            className={`nav-item ${isActive(path) ? 'active' : ''}`}
            onClick={() => navigate(path)}
            whileTap={{ scale: 0.92 }}
            whileHover={{ scale: 1.08 }}
            animate={isActive(path) ? {} : {}}
            transition={{ type: 'spring', stiffness: 400, damping: 22 }}
          >
            {typeof Icon === 'function' ? <Icon active={isActive(path)} /> : Icon}
            <span className="nav-label">{label}</span>
          </motion.button>
        ))}
      </nav>
    </motion.div>
  );
};

export default Footer;
